import { Observable, of } from 'rxjs'
import { catchError, merge, switchMap } from 'rxjs/operators'

import { Featured, Task } from '@skinsoft/types'
import { taskSelectors } from '@skinsoft/selectors'
import { TaskDataStore } from '@skinsoft/entity'
import { resolveAuthor } from '../../resolve-author'
import { resolveDescription } from './resolve-description'

export function toFeatured$(task: Task, locale: string): Observable<Featured> {
    const featured: Featured = {
        author: taskSelectors.author(task),
        date: taskSelectors.endDate(task),
        description: taskSelectors.associatedTasks(task)[0],
        headerDate: taskSelectors.startDate(task),
        // @ts-ignore
        highlight: TaskDataStore.highlightStates.includes(taskSelectors.state(task)),
        id: task.id,
        // @ts-ignore
        state: taskSelectors.state(task),
        stateLabel: `task.state.${taskSelectors.state(task)}`,
        title: taskSelectors.incrementalTitle(task) ?? '',
    };

    const featured$ = of(featured);

    const resolveDescription$  = (resolveDescription(featured$, locale) as Observable<Featured>).pipe(
        catchError(error => of({...featured, description: ''}))
    )

    return resolveDescription$.pipe(
        switchMap(res => {
            return (resolveAuthor(of(res)) as Observable<Featured>).pipe(
                catchError(error => of({ ...res, author: null }))
            )
        }),
    )
}
